import { render, staticRenderFns } from "./BankMain.vue?vue&type=template&id=d863ebda&scoped=true&"
import script from "./BankMain.vue?vue&type=script&lang=js&"
export * from "./BankMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d863ebda",
  null
  
)

export default component.exports